import { min } from 'date-fns'
import { formatInTimeZone } from 'date-fns-tz'

import { TIME_FORMAT, TIME_ZONE } from './constants'
import { MarketDataItem } from './MarketWatch.types'

const TZ_ABBREVIATION_MAP: Record<string, string> = {
  'America/New_York': 'ET'
}

/**
 * Formats a date in a given timezone with a fixed abbreviation (e.g. "ET" instead of "EDT"/"EST").
 */
export const formatWithFixedTZ = (
  date: Date,
  timeZone: string,
  fmt: string
): string => {
  const dateStr = formatInTimeZone(date, timeZone, fmt)
  const tzAbbr =
    TZ_ABBREVIATION_MAP[timeZone] ??
    new Intl.DateTimeFormat('en-US', { timeZone, timeZoneName: 'short' })
      .formatToParts(date)
      .find(p => p.type === 'timeZoneName')?.value
  return tzAbbr ? `${dateStr} ${tzAbbr}` : dateStr
}

/**
 * Returns the earliest trade timestamp from market data, formatted for display.
 */
export const getLastUpdatedTimestamp = (data: MarketDataItem[]): string => {
  const times = data
    .map(item =>
      item?.quoteInfo?.lstTrdTm ? new Date(item.quoteInfo.lstTrdTm) : null
    )
    .filter((t): t is Date => t !== null)

  if (times.length > 1) {
    const earliest = min(times)
    return formatWithFixedTZ(earliest, TIME_ZONE, TIME_FORMAT)
  }

  return ''
}
